var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inline-svg',{staticClass:"svg-icon",class:{'not-filled': _vm.notFilled},attrs:{"src":_vm.filepath,"width":_vm.width,"height":_vm.width,"viewBox":_vm.vbAsWidth ? `0 0 ${_vm.width || 24} ${_vm.width || 24}` : _vm.viewBox},on:{"click":function($event){return _vm.$emit('click', $event)},"loaded":_vm.onLoaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }